import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AccountModalMode } from '@/types';

/**
 * SC-1013 — ce que le client a déjà tapé ailleurs dans la page et qu'il ne doit
 * pas retaper dans la fenêtre. Posé par l'étape « compte » du parcours de
 * commande, qui connaît déjà nom, e-mail et téléphone de l'étape Coordonnées.
 */
export interface AccountModalPrefill {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

interface AccountModalState {
  open: boolean;
  mode: AccountModalMode;
  pendingEmail?: string;
  redirectTo?: string;
  prefill?: AccountModalPrefill;
}

const initialState: AccountModalState = {
  open: false,
  mode: 'login',
};

const slice = createSlice({
  name: 'accountModal',
  initialState,
  reducers: {
    openAccountModal(
      state,
      action: PayloadAction<{
        mode?: AccountModalMode;
        redirectTo?: string;
        prefill?: AccountModalPrefill;
      }>,
    ) {
      state.open = true;
      state.mode = action.payload.mode ?? 'login';
      state.redirectTo = action.payload.redirectTo;
      state.prefill = action.payload.prefill;
      state.pendingEmail = action.payload.prefill?.email ?? state.pendingEmail;
    },
    closeAccountModal(state) {
      state.open = false;
      state.pendingEmail = undefined;
      state.redirectTo = undefined;
      state.prefill = undefined;
    },
    setMode(state, action: PayloadAction<AccountModalMode>) {
      state.mode = action.payload;
    },
    setPendingEmail(state, action: PayloadAction<string | undefined>) {
      state.pendingEmail = action.payload;
    },
  },
});

export const { openAccountModal, closeAccountModal, setMode, setPendingEmail } = slice.actions;

export const selectAccountModal = (s: { accountModal: AccountModalState }) => s.accountModal;

export default slice.reducer;
